// Day templates (gym-tracker-spec.md section 6). 3 Upper + 1 Lower, 4 gym days.
// weekday auto-suggests today's routine (1 = Mon ... 7 = Sun).

import type { Routine } from '../domain/types';

export const ROUTINES: Routine[] = [
  {
    id: 'upper-a',
    dayLabel: 'Upper A (push + back)',
    weekday: 1,
    slots: [
      { exerciseId: 'dips', targetSets: 3 },
      { exerciseId: 'row-machine', targetSets: 3 },
      { exerciseId: 'bench-machine', targetSets: 3 },
      { exerciseId: 'db-ohp', targetSets: 3 },
      { exerciseId: 'side-raise-db', targetSets: 3 },
      { exerciseId: 'leg-extension-downstairs', targetSets: 3 },
    ],
  },
  {
    id: 'upper-b',
    dayLabel: 'Upper B (pull + chest)',
    weekday: 2,
    slots: [
      // Pull-ups first while fresh: a movement being reintroduced gets the best form.
      { exerciseId: 'assisted-pull-up', targetSets: 3 },
      { exerciseId: 'lat-pulldown', targetSets: 3 },
      { exerciseId: 'chest-supported-row', targetSets: 3 },
      { exerciseId: 'incline-db-press', targetSets: 3 },
      { exerciseId: 'biceps-curl', targetSets: 3 },
      { exerciseId: 'seated-leg-curl', targetSets: 3 },
    ],
  },
  {
    id: 'arms-delts',
    dayLabel: 'Arms + Delts (weak-point day)',
    weekday: 4,
    slots: [
      { exerciseId: 'biceps-curl', targetSets: 3 },
      { exerciseId: 'tricep-pushdown', targetSets: 3 },
      { exerciseId: 'side-raise-machine', targetSets: 3 },
      { exerciseId: 'butterfly-reverse', targetSets: 3 },
      { exerciseId: 'incline-db-curl', targetSets: 3 },
      { exerciseId: 'leg-extension-downstairs', targetSets: 3 },
    ],
  },
  {
    id: 'legs',
    dayLabel: 'Legs (full)',
    weekday: 5,
    slots: [
      { exerciseId: 'leg-press', targetSets: 4 },
      { exerciseId: 'nordic-curl', targetSets: 3 },
      { exerciseId: 'bulgarian-split-squat', targetSets: 3 },
      { exerciseId: 'lying-leg-curl', targetSets: 3 },
      { exerciseId: 'leg-extension', targetSets: 3 },
      { exerciseId: 'back-extension', targetSets: 3 },
      { exerciseId: 'captains-chair-raise', targetSets: 3 },
      { exerciseId: 'plank', targetSets: 3 },
      { exerciseId: 'russian-twist', targetSets: 3 },
    ],
  },
];

export const ROUTINE_BY_ID: Map<string, Routine> = new Map(ROUTINES.map((r) => [r.id, r]));
